// storyReducer.js
export const initialStoryState = {
  title: '',
  description: '',
  storyId: null,
  isValidStory: false,
  currentTab: 0,
  isGalleryStory: false,
}

export function storyReducer(state, action) {
  switch (action.type) {
    case 'SET_TITLE':
      return { ...state, title: action.payload }
    case 'SET_DESCRIPTION':
      return { ...state, description: action.payload }
    case 'SET_ID':
      return { ...state, storyId: action.payload }
    case 'SET_TAB':
      return { ...state, currentTab: action.payload }
    case 'SELECT_GALLERY_STORY':
      return {
        ...state,
        isGalleryStory: action.payload,
      }
    case 'RESET':
      return initialStoryState
    default:
      return state
  }
}
